<template>
  <div>
    <Spinner />
  </div>
</template>

<script>
import Spinner from "../components/Widgets/Spinner.vue";
import { mapActions } from "vuex";
import {
  buildPurchaseAnalyticsPayload,
  stashPurchaseAnalytics,
} from "../helpers/analytics";
import {
  stashBookingValidationErrors,
} from "../helpers/bookingValidation";
import { stashBookingConfirmation } from "../helpers/bookingConfirmation";

export default {
  name: "PaymentProcess",
  components: { Spinner },
  async created() {
    const { query } = this.$route;
    if (query.condition && query.condition === "nuitee-completion") {
      await this.completeNuiteePayment();
    } else {
      await this.processGatewayPayment();
    }
  },
  methods: {
    ...mapActions("payment", ["processPayment"]),
    ...mapActions("booking", ["processNuiteeBooking"]),
    async completeNuiteePayment() {
      const { query } = this.$route;
      const { transactionId, propertyId, prebookId, redirect_status } = query;
      if (!redirect_status === "succeeded") {
        this.$toastr.e("Error", this.$t("reservation.paymentError"));
        this.$router.push(`/listing/${propertyId}/reservation?tab=summary`);
      }
      let checkoutData = sessionStorage.getItem(`checkoutData-${propertyId}`);
      checkoutData = JSON.parse(checkoutData) || {};
      try {
        const { bookingData, successData, cart, date } = checkoutData;
        const { data } = await this.processNuiteeBooking({
          ...bookingData,
          date,
          cart,
          prebookId,
          propertyId,
          transactionId,
        });
        const reservationId = data.data.reservationId;
        stashPurchaseAnalytics(
          buildPurchaseAnalyticsPayload({
            checkoutData: { ...checkoutData, propertyId },
            transactionId: reservationId,
            value: successData?.total,
            currency: successData?.currency,
          })
        );
        this.$toastr.s("Success", this.$t("reservation.reservationSuccess"));
        stashBookingConfirmation({
          reservationId,
          email: bookingData?.bookerDetails?.email,
        });
        sessionStorage.removeItem(`checkoutData-${propertyId}`);
        this.$router.push({
          path: "/reservation_success",
          query: {
            ...successData,
            reservationId,
          },
        });
      } catch (error) {
        if (error?.fieldErrors) {
          stashBookingValidationErrors(propertyId, error.fieldErrors);
        }

        this.$toastr.e(
          "Error",
          error?.message || this.$t("reservation.paymentError")
        );
        this.$router.push(`/listing/${propertyId}/reservation?tab=summary`);
      }
    },
    async processGatewayPayment() {
      const { query } = this.$route;
      const { reference, gateway, status, sessionId, propertyId } = query;
      let checkoutData = null;
      try {
        checkoutData = JSON.parse(
          sessionStorage.getItem(`checkoutData-${propertyId}`) || "null"
        );
      } catch (_error) {
        checkoutData = null;
      }

      const { paymentStatus, reservationId, bookingData } =
        await this.processPayment({
          status,
          gateway,
          reference,
          sessionId,
          propertyId,
        });
      if (paymentStatus === "success") {
        if (checkoutData) {
          stashPurchaseAnalytics(
            buildPurchaseAnalyticsPayload({
              checkoutData: { ...checkoutData, propertyId },
              transactionId: reservationId,
              value: bookingData.total,
              currency: bookingData.currency,
            })
          );
        }
        this.$toastr.s("Success", this.$t("reservation.reservationSuccess"));
        stashBookingConfirmation({
          reservationId,
          email: bookingData.bookerEmail,
        });
        sessionStorage.removeItem(`checkoutData-${propertyId}`);
        this.$router.push({
          path: "/reservation_success",
          query: {
            propertyId,
            reservationId,
            total: bookingData.total,
            currency: bookingData.currency,
            type: bookingData.distributorType,
          },
        });
      } else {
        this.$toastr.e("Error", this.$t("reservation.paymentError"));
        this.$router.push(`/listing/${propertyId}/reservation?tab=summary`);
      }
    },
  },
};
</script>

<style scoped></style>
